import { onMounted, ref } from 'vue';

/**
 * 要素の幅と親要素の幅を基にtooltipを表示するかどうか判定するcomposable
 */
export function useTooltipVisibility() {
  const elementRef = ref<HTMLElement>();
  const isTooltipVisible = ref(false);

  /**
   * tooltip表示判定を実行
   */
  const checkTooltipVisibility = () => {
    const element = elementRef.value;
    if (!element) {
      isTooltipVisible.value = false;
      return;
    }
    const parentElement = element.parentElement;

    // 親要素が存在しない場合は親要素幅を超過しないのでtooltipを表示しない
    if (!parentElement) {
      isTooltipVisible.value = false;
      return;
    }

    // 親要素よりも横幅が大きい場合はtooltipを表示する
    isTooltipVisible.value = element.offsetWidth > parentElement.offsetWidth;
  };

  onMounted(() => {
    checkTooltipVisibility();
  });

  return {
    elementRef,
    isTooltipVisible,
    checkTooltipVisibility,
  };
}
